import React from "react";
import { Check } from "lucide-react";

const STEPS = [
  { id: 1, label: "Event Details" },
  { id: 2, label: "Cost Estimate" },
  { id: 3, label: "Recipient Info" },
  { id: 4, label: "Proposal" },
];

export default function StepIndicator({ current }) {
  return (
    <ol data-testid="step-indicator" className="space-y-1">
      {STEPS.map((s, idx) => {
        const done = current > s.id;
        const active = current === s.id;
        return (
          <li key={s.id} className="flex items-start gap-3">
            <div className="flex flex-col items-center">
              <div
                data-testid={`step-dot-${s.id}`}
                className={`h-9 w-9 rounded-full flex items-center justify-center text-sm font-semibold transition-colors ${
                  done
                    ? "bg-primary text-white"
                    : active
                    ? "bg-primary text-white ring-4 ring-accent"
                    : "bg-secondary text-muted-foreground"
                }`}
              >
                {done ? <Check className="h-4 w-4" /> : s.id}
              </div>
              {idx < STEPS.length - 1 && (
                <div className={`w-0.5 h-10 my-1 ${done ? "bg-primary" : "bg-border"}`} />
              )}
            </div>
            <div className="pt-1.5">
              <p
                className={`font-display font-600 text-sm ${
                  active || done ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                {s.label}
              </p>
              <p className="text-xs text-muted-foreground">Step {s.id} of 4</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
